import { Service } from '../models';

/**
 * Resolves the duration (in milliseconds) a service occupies for a given party size.
 * Falls back to the service's base duration when no rule matches or no rules are configured.
 */
export function getDurationForPartySize(service: Service | undefined, partySize: number | undefined): number {
  if (!service) {
    return 0;
  }

  const rules = service.durationRules?.filter(rule => rule.enabled);
  if (!rules?.length || typeof partySize !== 'number') {
    return service.duration?.miliseconds ?? 0;
  }

  const rule = rules.find(r => partySize >= r.minPartySize && partySize <= r.maxPartySize);

  return rule?.milliseconds ?? service.duration?.miliseconds ?? 0;
}
